/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPoolingFlightsFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, serializePoolingFlights, serializePoolingFlightSearchRequest, type PoolingFlights, type PoolingFlightSearchRequest, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /PoolingFlight/Get
 */
export interface GetRequestBuilder extends BaseRequestBuilder<GetRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PoolingFlights>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     post(body: PoolingFlightSearchRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PoolingFlights | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: PoolingFlightSearchRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const GetRequestBuilderUriTemplate = "{+baseurl}/PoolingFlight/Get";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: GetRequestBuilderUriTemplate,
        responseBodyContentType: "application/json, text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPoolingFlightsFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializePoolingFlightSearchRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
